import * as React from "react";
import { Hamburger, mergeClasses, useRestoreFocusTarget } from "@fluentui/react-components";
import { bundleIcon, NavigationFilled, NavigationRegular } from "@fluentui/react-icons";

import Navbar from "./Navbar";
import UserAccount from "./UserAccount";

import { useBrandBarStyles, useIconButtonStyles } from "../styles/styles";
import { ThemeContext } from "../store/theme-context-api";
import { DrawerContext } from "../store/drawer-navigator-context-api";

const NavigationIcon = bundleIcon(NavigationFilled, NavigationRegular);

export default function Header() {
  const { isDarkTheme } = React.useContext(ThemeContext);
  const { isDrawerOpen, setIsDrawerOpen } = React.useContext(DrawerContext);
  const brandBarStyles = useBrandBarStyles();
  const restoreFocusTargetAttributes = useRestoreFocusTarget();
  const iconStyles = useIconButtonStyles();

  return (
    <nav
      className={mergeClasses(brandBarStyles.container, isDarkTheme ? brandBarStyles.dark : brandBarStyles.light)}
      style={{
        top: "0px",
      }}
    >
      <Hamburger
        icon={<NavigationIcon />}
        onClick={() => setIsDrawerOpen(!isDrawerOpen)}
        {...restoreFocusTargetAttributes}
        aria-expanded={isDrawerOpen}
        className={isDarkTheme ? iconStyles.dark : iconStyles.light}
      />

      <Navbar />

      <div className="flex items-center gap-[8px]">
        <UserAccount />
      </div>
    </nav>
  );
}
